import { AxiosRequestConfig } from 'axios';

import { Client } from '../Client';

export type ProcessStatus =
    | 'Opened'
    | 'Created'
    | 'Closed'
    | 'NotFound'
    | 'Unknown'
    | 'Finished'
    | 'Error';

export type ProcessErrorCode =
    | 'LOGIN_TIMEOUT'
    | 'SERVER_ERROR'
    | 'INVALID_USER_DATA';

export class OnescoreClient extends Client {
    constructor(requestConfig: AxiosRequestConfig) {
        super(requestConfig);
    }

    public getProcessId = async (params: {
        data: {
            personNumber: string;
            phoneNumber: string;
            gjeldsConsent: boolean;
        };
    }) => {
        return this.client
            .post<{
                processId: string;
            }>(`/finance-data-process`, params.data)
            .then((response) => response.data.processId);
    };

    public checkProcessStatus = (params: { processId: string }) =>
        this.client
            .get<{
                state: ProcessStatus;
                errorCode?: ProcessErrorCode;
            }>(`/finance-data-process/${params.processId}`)
            .then((response) => {
                return response.data;
            });

    public getLoanData = async (params: { processId: string }) => {
        return this.client
            .get<any>(`/loan_applications/${params.processId}`)
            .then((response) => response.data);
    };
}
